<template>
  <section class="files-page">

    <div class="top-bar">
      <div class="top-bar--left">
        <b-button @click="tabIndex=0" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 0 }">{{$t('profiles.tabs.active')}}
        </b-button>
        <b-button @click="tabIndex=1" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 1 }">{{$t('profiles.tabs.deleted')}}
        </b-button>
        <b-button v-if="showDefaultProfiles" @click="tabIndex=2" size="-tab" variant="-gray"
                  :class="{ 'btn--primary': tabIndex === 2 }">{{$t('profiles.tabs.default')}}
        </b-button>
      </div>
      <div class="top-bar--right">
        <b-form-input :placeholder="$t('profiles.search')" v-model="search" @keydown.enter.native="searchVal=search" class="inp inp--combo"></b-form-input>
        <b-button variant="-combo btn--ternary btn--outline" @click="searchVal=search"><i class="icon icon--search"></i></b-button>
        <slicing-profile-add-button></slicing-profile-add-button>
      </div>
    </div>

    <b-tabs>
      <b-tab v-if="tabIndex===0" active>
        <container-loader v-if="!isProfilesLoaded"></container-loader>
        <slicing-profiles-active-table v-else :search="search"></slicing-profiles-active-table>
      </b-tab>
      <b-tab v-if="tabIndex===1" active>
        <container-loader v-if="!isProfilesLoaded"></container-loader>
        <slicing-profiles-deleted-table v-else :search="search"></slicing-profiles-deleted-table>
      </b-tab>
      <b-tab v-if="showDefaultProfiles && tabIndex===2" active>
        <container-loader v-if="!isProfilesLoaded"></container-loader>
        <slicing-profiles-default-table v-else :search="search"></slicing-profiles-default-table>
      </b-tab>
    </b-tabs>
  </section>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";
  import SlicingProfilesActiveTable from "../components/slicingprofiles/SlicingProfilesActiveTable";
  import SlicingProfilesDeletedTable from "../components/slicingprofiles/SlicingProfilesDeletedTable";
  import SlicingProfilesDefaultTable from "../components/slicingprofiles/SlicingProfilesDefaultTable";
  import SlicingProfileAddButton from "../components/slicingprofiles/SlicingProfileAddButton";


  export default {
    name: "Profiles",
    components: {
      SlicingProfileAddButton,
      SlicingProfilesDeletedTable,
      SlicingProfilesDefaultTable,
      SlicingProfilesActiveTable
    },
    data() {
      return {
        tabIndex: 0,
        search: null,
        searchVal: null,
        intervalPromise: null
      }
    },
    created() {
      this.fetchProfiles();
      this.intervalPromise = setInterval(() => {
        this.fetchProfiles();
      }, 2000);
    },
    beforeDestroy() {
      clearInterval(this.intervalPromise);
    },
    computed: {
      ...mapGetters(['isProfilesLoaded', 'isOemAdmin']),
      
      showDefaultProfiles() {
        return this.isOemAdmin;
      }
    },
    methods: {
      ...mapActions(['fetchProfiles'])
    }
  }
</script>
